import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { MagneticButton } from '../../common/AnimationUtils';

import styles from '../styles/CTASection.module.css';

const CTASection = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"]
    });

    const y = useTransform(scrollYProgress, [0, 1], [30, -30]);

    return (
        <section ref={ref} className={styles.section}>
            <motion.div
                className={styles.container}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                style={{ y }}
            >
                {/* Animated background pulse */}
                <motion.div
                    className={styles.backgroundGlow}
                    animate={{
                        scale: [1, 1.05, 1],
                        opacity: [0.3, 0.5, 0.3],
                    }}
                    transition={{
                        duration: 4,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                />

                <div className={styles.content}>
                    <motion.h2
                        className={styles.title}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        Ready to transform your workflow?
                    </motion.h2>
                    <motion.p
                        className={styles.text}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                    >
                        Join thousands of users who are already building the future with JetChats.
                        Start your journey today.
                    </motion.p>
                    <motion.div
                        className={styles.buttons}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <MagneticButton>
                            <Link to="/register" className={styles.primaryButton}>
                                Get Started Free
                            </Link>
                        </MagneticButton>
                    </motion.div>
                </div>
            </motion.div>
        </section>
    );
};

export default CTASection;
